import { apiWsBaseUrl, isNative } from '../../lib/platform.js';
import { getAuthToken } from '../../lib/apiClient.js';

/**
 * URL del WebSocket de voz para la app nativa (Fase 23, A.4).
 *
 * En **web** devuelve `null` → el cliente de voz cae a su default same-origin
 * (`buildSessionUrl` en `@orborix/voice-client`), exactamente como hoy. En
 * **nativo** arma la URL ABSOLUTA del backend con el token ya embebido como
 * `?token=` — el WS del backend ya lo lee con precedencia 1 (`wsServer.ts`), así
 * que NO hace falta tocar `buildSessionUrl` (respeta `opts.url` tal cual). Ver
 * `docs/speak-plan/23-mobile-capacitor.md` §3.3.
 */

const WS_PATH = '/ws/session';

/**
 * Pura: compone la URL del WS desde la base `wss://…` y el token. Si no hay token
 * (no logueado), igual apunta al host correcto y deja que el WS rechace por auth
 * — mejor que conectar al origin equivocado (`capacitor://localhost`).
 */
export function buildVoiceWsUrl(wsBase: string, token: string | null): string {
  const base = `${wsBase}${WS_PATH}`;
  return token ? `${base}?token=${encodeURIComponent(token)}` : base;
}

/** URL del WS de voz para el call-site nativo; `null` en web (default same-origin). */
export function nativeVoiceUrl(): string | null {
  if (!isNative) return null;
  return buildVoiceWsUrl(apiWsBaseUrl(), getAuthToken());
}
